import { FormMode } from '../../controls/common/form-mode';
import { BoxGroupFormContext } from './box-group-form-context';

export class BoxDetailContext {
    /**
     * Indique si le formulaire est en mode édition (true) ou en mode consultation (false).
     */
    private _formMode: FormMode = FormMode.Reading;

    public get formMode(): FormMode {
        return this._formMode;
    }

    public set formMode(value: FormMode) {
        this._formMode = value;
        this.boxGroupContext.mode = value;
    }

    public editedBoxGroupId: string = null;

    public boxGroupContext: BoxGroupFormContext = new BoxGroupFormContext();
}
